var _g, _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 19,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 16,
    fill: "#DD4B39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3346 14.8343L14.687 23.4819C14.2589 23.9577 14.0178 24.5626 14.0166 25.1645C14.0153 25.7663 14.2539 26.3162 14.6803 26.6939L19.3892 31.4028C19.7669 31.8292 20.3168 32.0678 20.9187 32.0665C21.5205 32.0653 22.1254 31.8242 22.6012 31.3961L31.2488 22.7485C31.6769 22.2727 31.918 21.6678 31.9192 21.0659C31.9205 20.4641 31.6819 19.9142 31.2556 19.5365L26.5466 14.8276C26.1689 14.4012 25.619 14.1626 25.0172 14.1639C24.4153 14.1651 23.8104 14.4062 23.3346 14.8343ZM29.7723 21.0198C29.83 21.0675 29.8742 21.1293 29.9016 21.2004C29.9289 21.2715 29.9385 21.3499 29.9298 21.4295L21.2896 30.0697C21.209 30.0821 21.129 30.0749 21.0563 30.0487C20.9836 30.0226 20.9205 29.9782 20.8725 29.9196L16.1636 25.2106C16.1064 25.1624 16.0626 25.1005 16.0353 25.0295C16.008 24.9586 15.998 24.8804 16.006 24.8009L24.6462 16.1608C24.7268 16.1483 24.8069 16.1555 24.8795 16.1817C24.9522 16.2078 25.0153 16.2522 25.0633 16.3108L29.7723 21.0198Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9893 18.4987L27.9143 25.4236",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.207bd77b.svg";
export { ForwardRef as ReactComponent };